const contracts = require('./scripts/contracts');

module.exports = contracts;